import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import UniqueIdPrompt from '../RMFUniqueIdPrompt/RMFUniqueIdPrompt';

import {
  TXTWCL_WeXll_use_your_place_of_birth__ELL,
  TXTWCL_Where_were_you_bornX,
  TXTWCL_Your_Birth_Place
} from './RMFPlaceOfBirth.messages.json';
import PlaceOfBirthFields from './components/PlaceOfBirthFields/PlaceOfBirthFields';

const RMFPlaceOfBirth: React.FC = () => (
  <Container
    page={RMFPlaceOfBirth}
    headerProps={{
      title: <Translation {...TXTWCL_Your_Birth_Place} />
    }}
    pageTopTitle={<Translation {...TXTWCL_Where_were_you_bornX} />}
    pageTopSubtitle={<Translation {...TXTWCL_WeXll_use_your_place_of_birth__ELL} />}
  >
    <PlaceOfBirthFields />
    <CTAButton />
    <UniqueIdPrompt />
  </Container>
);

RMFPlaceOfBirth.displayName = 'RMFPlaceOfBirth';

export default RMFPlaceOfBirth;
